<!-- 更多操作 -->
<template>
  <div>
    <!-- 文件夹操作菜单 -->
    <van-action-sheet :actions="folderMoreList" v-model="showFolder" cancelText="取消" class="uActionSheetStyle" @close="close" @select="selectFolder" />
    <!-- 文件操作菜单 -->
    <van-action-sheet :actions="fileMoreList" v-model="showFile" cancelText="取消" class="uActionSheetStyle" @close="close" @select="selectFile" />

    <!-- 属性弹框 -->
    <van-popup v-model="attributeShow" position="bottom">
      <div class="attributeContent">
        <div class="attributeItem">
          <span>文件大小：</span>
          <span class="attributeItemData">{{ Pitem.isFolder === 1 ? "--" : Pitem.fileSize }}</span>
        </div>
        <div class="attributeItem">
          <span>修改人：</span>
          <span class="attributeItemData">{{ Pitem.checkInUser || "--" }}</span>
        </div>
        <div class="attributeItem">
          <span>修改时间：</span>
          <span class="attributeItemData">{{ Pitem.checkInDate || "--" }}</span>
        </div>
        <div class="attributeItem">
          <span>备注：</span>
          <span class="attributeItemData">{{ Pitem.remark || "--" }}</span>
        </div>
      </div>
      <div class="attributeClose" @click="attributeClose">取消</div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import { downloadFile, downloadUrltoken, downloadFileShowPrompt } from "@/CommonDP/utils";
import docService from "@/CommonDP/service/doc-service";

export default {
  props: ["rootPrjId"],
  components: {},
  data() {
    return {
      // 文件夹操作菜单
      folderMoreList: [],
      folderPriviList: [
        // { name: "下载", Privi: this.$allPerms.MYDOC_DOWN },
        { name: "属性", Privi: "" }
      ],
      // 文件操作菜单
      fileMoreList: [],
      filePriviList: [
        // { name: "下载", Privi: this.$allPerms.MYDOC_DOWN },
        { name: "属性", Privi: "" }
      ],
      showFolder: false,
      showFile: false,
      Pitem: {}, // 当前操作的文档
      selectArr: [], // 选中的文档

      attributeShow: false // 属性弹框
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    })
  },
  mounted() {},
  methods: {
    // 设置文件夹权限
    setFolderPrivi(items) {
      this.Pitem = items || {};
      this.folderMoreList = this.folderPriviList.filter((item) => (item.Privi ? checkPermission(item.Privi) : true));
      this.showFolder = true;
    },
    // 设置文件权限
    setFilePrivi(items) {
      this.Pitem = items || {};
      this.fileMoreList = this.filePriviList.filter((item) => (item.Privi ? checkPermission(item.Privi) : true));
      this.showFile = true;
    },
    // 关闭事件
    close() {
      this.showFolder = false;
      this.showFile = false;
    },

    // 文件夹菜单事件
    selectFolder(val) {
      if (val.name == "下载") this.downloadDoc(this.Pitem);
      if (val.name == "属性") this.queryAttribute();
    },
    // 文件菜单事件
    selectFile(val) {
      if (val.name == "下载") this.downloadDoc(this.Pitem);
      if (val.name == "属性") this.queryAttribute();
    },

    // 属性
    queryAttribute() {
      this.close();
      this.attributeShow = true;
    },
    // 关闭属性
    attributeClose() {
      this.attributeShow = false;
    },
    // 下载文件
    async downloadDoc(row) {
      const prjId = this.rootPrjId || "";
      const { userId } = this.userInfo || {};
      if (row.isFolder !== 1) {
        const fileId = row.folderId;
        const version = row.fileVersion;
        const downzipurl = downloadUrltoken(prjId, fileId, version);
        downloadFile(downzipurl);
      } else {
        const params = {
          folderId: row.folderId,
          rootDirectory: row.folderName,
          prjId: prjId,
          enterpriseId: this.enterpriseId,
          userId: userId
        };
        docService.downloadfolder(params).then((response) => {
          const fileName = row.folderName + ".zip";
          downloadFileShowPrompt(fileName, response);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .uActionSheetStyle {
  .van-action-sheet__content {
    max-height: 50vh;
  }
  .van-action-sheet__item {
    border-bottom: 1px solid #e5e8f1 !important;
    .van-action-sheet__name {
      font-size: 16px;
      color: var(--key-color);
    }
  }

  .van-action-sheet__cancel {
    font-size: 16px;
    color: #007af5;
  }

  .van-action-sheet__gap {
    height: 1px !important;
    background-color: #e5e8f1 !important;
  }
}

.modalStyle {
  width: 90vw;
  padding: 3vh 4vw;

  .text {
    padding: 3vh 5vw;
    font-size: 16px;
    white-space: pre-wrap;
    text-align: center;
  }

  .buttonSlider {
    width: 100%;
    padding: 2vh 0;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .van-button {
      width: 40%;
    }
  }
}

.modalRenameStyle {
  width: 90vw;
  padding: 0 4vw;

  .text {
    padding: 3vh 5vw;
    font-size: 16px;
    white-space: pre-wrap;
    text-align: center;
  }

  .input {
    border: 1px solid #e5e8f1 !important;
    background: #f5f5f5;
  }

  .buttonSlider {
    width: 100%;
    padding: 3vh 0;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .van-button {
      width: 40%;
    }
  }
}

.attributeContent {
  max-height: 240px;
  padding: 20px;

  .attributeItem {
    white-space: nowrap;
    overflow: overlay !important;
    overflow: auto;
    span {
      font-size: 16px;
      line-height: 40px;
    }
    .attributeItemData {
      color: var(--key-color);
    }
  }
}

.attributeClose {
  border-top: 1px solid #e5e8f1 !important;
  font-size: 16px !important;
  color: #007af5 !important;
  line-height: 50px;
  text-align: center;
}

.moveToPopup {
  .moveTo {
    width: 100vw;
    padding: 2vh 5vw;
    display: flex;
    justify-content: space-around;

    .van-button {
      width: 40%;
    }
  }
}

.shareStyle {
  width: 100vw;
  padding: 30px 5vw 40px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .van-button {
    width: 120px;
    margin-top: 20px;
  }

  .linkText {
    width: 100%;
    margin-top: 20px;
    font-size: 14px;
    color: var(--key-color);
    word-break: break-all;
  }

  .linkBtn {
    margin-top: 20px !important;
    font-size: 14px;
    color: #007af5;
    cursor: pointer;
  }
}
</style>
